__turbopack_context__.v({
  "alignCenter": "_2MpshG_alignCenter",
  "alignTop": "_2MpshG_alignTop",
  "iconCell": "_2MpshG_iconCell",
  "sizeLg": "_2MpshG_sizeLg",
  "sizeMd": "_2MpshG_sizeMd",
  "sizeSm": "_2MpshG_sizeSm",
});
